var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { Item } from './Item';
import { DivTag, LiTag, UlTag } from '../../Utils/AtomicTag';
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this.keys = {};
        _this.classFactory = function () {
            var atomicCls = ['border', 'border-solid', 'border-gray-200', 'bg-white'];
            var atomicHdCls = [
                'px-px-24',
                'py-px-16',
                'border-b',
                'border-solid',
                'border-gray-200',
            ];
            var atomicFtCls = [
                'px-px-24',
                'py-px-16',
                'border-t',
                'border-solid',
                'border-gray-200',
            ];
            var atomicBdCls = ['px-px-24'];
            var atomicItems = ['text-base'];
            var atomicItem = [
                'flex',
                'justify-between',
                'items-center',
                'py-px-16',
                'border-b',
                'border-solid',
                'border-gray-200',
                'last:border-b-0',
            ];
            return {
                atomicCls: atomicCls,
                atomicHdCls: atomicHdCls,
                atomicBdCls: atomicBdCls,
                atomicFtCls: atomicFtCls,
                atomicItems: atomicItems,
                atomicItem: atomicItem,
            };
        };
        _this.renderContentItem = function (item, index) {
            var renderItem = _this.props.renderItem;
            var key = "list-item-" + index;
            if (!renderItem)
                return null;
            _this.keys[index] = key;
            return renderItem(item, index);
        };
        _this.renderList = function () {
            var _a = _this.props, header = _a.header, footer = _a.footer, data = _a.data, children = _a.children, className = _a.className, renderItem = _a.renderItem, rest = __rest(_a, ["header", "footer", "data", "children", "className", "renderItem"]);
            var childrenContent;
            //元子类样式
            var _b = _this.classFactory(), atomicCls = _b.atomicCls, atomicHdCls = _b.atomicHdCls, atomicBdCls = _b.atomicBdCls, atomicFtCls = _b.atomicFtCls, atomicItems = _b.atomicItems, atomicItem = _b.atomicItem;
            if (Array.isArray(data) && data.length > 0) {
                var items = __spread(data).map(function (item, index) {
                    return _this.renderContentItem(item, index);
                });
                var childrenList = React.Children.map(items, function (child, index) {
                    return (React.createElement(LiTag, { atomics: atomicItem, key: _this.keys[index], autoPrefixedClassName: "list-content-li" }, child));
                });
                childrenContent = (React.createElement(UlTag, { atomics: atomicItems, autoPrefixedClassName: "list-content-ul" }, childrenList));
            }
            return (React.createElement(DivTag, __assign({ name: List.NAME, atomics: atomicCls, className: className }, rest),
                header && (React.createElement(DivTag, { atomics: atomicHdCls, autoPrefixedClassName: "list-header" }, header)),
                React.createElement(DivTag, { atomics: atomicBdCls, autoPrefixedClassName: "list-content" },
                    childrenContent,
                    children),
                footer && React.createElement(DivTag, { atomics: atomicFtCls }, footer)));
        };
        return _this;
    }
    List.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.renderList());
    };
    List.Item = Item;
    // 默认参数，单独从外部文件引入
    List.defaultProps = defaultProps;
    List.NAME = 'list';
    List.displayName = 'List';
    return List;
}(PureComponent));
export { List };
